/* global OneSignalDeferred */
import React, { useState, useEffect, Fragment } from "react";
import { Card } from "react-bootstrap";
import { academylist, createsetting, listsetting, downloadBackup, uploadCertificateImage } from "../../../services/admin";
import Select from "react-select";
import { stuacademicyearlist } from "../../../services/master";
import moment from "moment/moment";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { tokensave } from "../../../services/common";
import { applyOneSignalIdentity } from "../../../services/onesignal";

const SettingDefault = () => {
    const [aclist, setAcList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [ayear, setAYear] = useState("");
    const [alist, setAList] = useState([]);

    const [ddate, setDDate] = useState("");
    const [cdate, setCDate] = useState("");

    const [invno, setInvNo] = useState("");
    const [rcount, setRCount] = useState("");
    const [transportRenewalMsg, setTransportRenewalMsg] = useState(
        "Dear Admin, Your transport vehicle ({vehicle}) renewal for route ({route}) is due on {date}. Kindly complete the renewal before the due date to continue transport service."
    );
    const [taxcount, setTaxCount] = useState("");
    const [taxrenewl, setTaxRenewal] = useState(
        "Dear Admin, Your transport vehicle ({vehicle}) tax renewal for route ({route}) is due on {date}. Kindly complete the renewal before the due date to continue transport service."
    );
    const [poccount, setPocCount] = useState("");
    const [pocrenewal, setPocRenewal] = useState(
        "Dear Admin, Your transport vehicle ({vehicle}) POC renewal for route ({route}) is due on {date}. Kindly complete the renewal before the due date to continue transport service."
    );
    const [inscount, setInsCount] = useState("");
    const [insrenewel, setInsRenewal] = useState(
        "Dear Admin, Your transport vehicle ({vehicle}) insurance renewal for route ({route}) is due on {date}. Kindly complete the renewal before the due date to continue transport service."
    );
    const [attpush, setAttPush] = useState("Dear {student}, Your attendance for class {class} on {date} ({time}) is marked has {status}.");
    const [transportattpush, setTransportAttPush] = useState("Dear {student}, Transport attendance for vehicle {vehicle} on route {route} on {date} ({time}) is marked as {status}.");
    const [feestructurepush, setFeeStructurePush] = useState("New fee structure created: {feetype} - Amount: ₹{amount} for academic year {year}.");
    const [feepaymentpush, setFeePaymentPush] = useState("Fee payment received: {feetype} - Paid: ₹{paid}. Pending: ₹{pending}. Date: {date}.");
    const [homeworkpush, setHomeworkPush] = useState("Dear {student}, New homework for {subject} has been assigned. Due: {date}.");

    const [transportTime, setTransportTime] = useState("");
    const [certHeaderUrl, setCertHeaderUrl] = useState("");
    const [certFooterUrl, setCertFooterUrl] = useState("");
    const [certHeaderFile, setCertHeaderFile] = useState(null);
    const [certFooterFile, setCertFooterFile] = useState(null);
    const [certUploading, setCertUploading] = useState({ header: false, footer: false });
    const baseUrl = (localStorage.getItem("activeBaseUrl") || "").replace("/api", "");

    const [backupFrequency, setBackupFrequency] = useState("");
    const [backupTime, setBackupTime] = useState("");
    const [lastBackupAt, setLastBackupAt] = useState("");
    const [backupLoading, setBackupLoading] = useState(false);

    // Push notification permission
    const [pushPermission, setPushPermission] = useState("default"); // "default" | "granted" | "denied"
    const [pushLoading, setPushLoading] = useState(false);

    useEffect(() => {
        if ("Notification" in window) {
            setPushPermission(Notification.permission);
        }
    }, []);

    async function handleEnableNotifications() {
        if (!("Notification" in window)) {
            toast.error("Push notifications are not supported in this browser.");
            return;
        }
        setPushLoading(true);
        try {
            await new Promise((resolve) => {
                OneSignalDeferred.push(async function (OneSignal) {
                    try {
                        // If not yet opted in, trigger the browser permission prompt
                        if (!OneSignal.User.PushSubscription.optedIn) {
                            await OneSignal.User.PushSubscription.optIn();
                            // Give OneSignal a moment to assign the subscription ID
                            await new Promise((r) => setTimeout(r, 1500));
                        }

                        // Prefer the freshly-read subscription id; fall back to the
                        // value the change listener may have stored in localStorage.
                        let token = OneSignal.User.PushSubscription.id;
                        if (!token) {
                            const stored = localStorage.getItem("notitoken");
                            token = stored ? stored.replace(/^"|"$/g, "") : "";
                        }
                        if (token) {
                            // Always refresh localStorage with latest token
                            localStorage.setItem("notitoken", JSON.stringify(token));
                            const temp = new FormData();
                            temp.append("academy_id", localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "1");
                            temp.append("login_user_id", localStorage.getItem("UID"));
                            temp.append("role_id", localStorage.getItem("Role"));
                            temp.append("device_token", token);
                            const saved = await tokensave(temp);
                            if (saved && saved.status === true) {
                                applyOneSignalIdentity(saved.data);
                            }
                            toast.success("Push notifications enabled for this device.");
                            setPushPermission("granted");
                        } else {
                            toast.error("Could not get notification token. Please allow notifications in your browser.");
                        }
                    } catch (err) {
                        toast.error("Failed to enable notifications.");
                    }
                    resolve();
                });
            });
        } catch (err) {
            toast.error("Failed to enable notifications.");
        }
        setPushLoading(false);
    }

    useEffect(() => {
        // setDDate(moment(new Date()).format("YYYY-MM-DD"));
        setCDate(moment(new Date()).format("YYYY-MM-DD"));
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAcList(arr);
                }
            }
        });

        const temp = new FormData();
        if (localStorage.getItem("Role") !== "1") {
            temp.append("academy_id", localStorage.getItem("academy"));
        }
        if (localStorage.getItem("Role") === "1") {
            temp.append("role_id", localStorage.getItem("Role"));
        }
        listsetting(temp).then((resp) => {
            if (resp.status === true && resp.data !== null) {
                academylist().then((res) => {
                    if (res.status === true) {
                        let arr = [];
                        if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                                if (res.data.details[i].id == resp.data.academy_id) {
                                    arr.push({
                                        value: res.data.details[i].id,
                                        label:
                                            res.data.details[i].name + " - " + res.data.details[i].code,
                                    });
                                }
                                setAcaID(arr[0]);
                            }
                            const item = res.data.details.find((x) => x.id === resp.data.academy_id);
                            listall(item.id);

                        }
                    }
                });
                setInvNo(resp.data.invoice_no);
                setDDate(resp.data.academy_date);
                setAYear(resp.data.year_id);
                if (resp.data.reg_renewal_msg) setTransportRenewalMsg(resp.data.reg_renewal_msg);
                if (resp.data.reg_renewal_days) setRCount(resp.data.reg_renewal_days);
                if (resp.data.tax_renewal_msg) setTaxRenewal(resp.data.tax_renewal_msg);
                if (resp.data.tax_renewal_days) setTaxCount(resp.data.tax_renewal_days);
                if (resp.data.poc_renewal_msg) setPocRenewal(resp.data.poc_renewal_msg);
                if (resp.data.poc_renewal_days) setPocCount(resp.data.poc_renewal_days);
                if (resp.data.ins_renewal_msg) setInsRenewal(resp.data.ins_renewal_msg);
                if (resp.data.ins_renewal_days) setInsCount(resp.data.ins_renewal_days);
                if (resp.data.transport_notification_time) setTransportTime(resp.data.transport_notification_time);
                if (resp.data.transport_attendance_push_notification) setTransportAttPush(resp.data.transport_attendance_push_notification);
                if (resp.data.fee_structure_push_notification) setFeeStructurePush(resp.data.fee_structure_push_notification);
                if (resp.data.fee_payment_push_notification) setFeePaymentPush(resp.data.fee_payment_push_notification);
                if (resp.data.homework_push_notification) setHomeworkPush(resp.data.homework_push_notification);
                if (resp.data.certificate_header) setCertHeaderUrl(baseUrl + "/" + resp.data.certificate_header);
                if (resp.data.certificate_footer) setCertFooterUrl(baseUrl + "/" + resp.data.certificate_footer);
                if (resp.data.backup_frequency) setBackupFrequency(resp.data.backup_frequency);
                if (resp.data.backup_time) setBackupTime(resp.data.backup_time);
                if (resp.data.last_backup_at) setLastBackupAt(resp.data.last_backup_at);

            }
        })
    }, []);

    function handleAcademy(e) {
        setAYear("");
        if (e !== null) {
            setAcaID(e);
            listall(e.value);
        } else {
            setAcaID("");
            listall("");
        }
    }
    function listall(aid) {
        setAList([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid);
        }
        stuacademicyearlist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    setAList(res.data);
                }
            }
        });

    }
    async function handleUploadCertImage(type) {
        const file = type === "header" ? certHeaderFile : certFooterFile;
        if (!file) { toast.error("Please select an image first"); return; }
        const aca = acaid?.value || localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
        if (!aca) { toast.error("Please select academy first"); return; }
        setCertUploading((u) => ({ ...u, [type]: true }));
        const temp = new FormData();
        temp.append("image", file);
        temp.append("type", type);
        temp.append("academy_id", aca);
        const res = await uploadCertificateImage(temp);
        if (res?.status) {
            const url = baseUrl + "/" + res.data.path;
            if (type === "header") setCertHeaderUrl(url);
            else setCertFooterUrl(url);
            toast.success(`Certificate ${type} image uploaded.`);
        } else {
            toast.error(`Failed to upload certificate ${type} image.`);
        }
        setCertUploading((u) => ({ ...u, [type]: false }));
    }

    async function handleDownloadBackup() {
        setBackupLoading(true);
        Swal.fire({
            title: "Database Backup",
            html: "Backup is in progress, please wait...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => Swal.showLoading(),
        });
        const academyId = acaid?.value || localStorage.getItem("academy") || "";
        const temp = new FormData();
        temp.append("academy_id", academyId);
        const filename = `backup_academy${academyId}_${moment(new Date()).format("YYYY-MM-DD_HH-mm-ss")}.sql.gz`;
        try {
            const res = await downloadBackup(temp);
            if (res?.status === true) {
                Swal.fire({
                    icon: "success",
                    title: "Backup Complete",
                    html: `<p class="mb-2">Database backup downloaded successfully.</p>
                           <div style="background:#f4f6f9;padding:10px 14px;border-radius:6px;text-align:left;">
                             <span class="text-muted" style="font-size:12px;">Saved to</span><br/>
                             <span style="font-family:monospace;font-size:13px;word-break:break-all;">
                               <i class="fa fa-folder-open text-warning me-1"></i>
                               Downloads/<strong>${filename}</strong>
                             </span>
                           </div>`,
                    confirmButtonColor: "#6259ca",
                });
            } else {
                Swal.fire({ icon: "error", title: "Backup Failed", text: "Could not generate the backup. Please try again.", confirmButtonColor: "#6259ca" });
            }
        } catch {
            Swal.fire({ icon: "error", title: "Backup Failed", text: "Could not generate the backup. Please try again.", confirmButtonColor: "#6259ca" });
        }
        setBackupLoading(false);
    }

    const [errmsg, setErrMsg] = useState(false);
    function handlesubmit(e) {
        e.preventDefault();
        setErrMsg(true);
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                toast.error("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }
        if (valid === "") {
            if (ayear !== "") {
                const temp = new FormData();
                temp.append("academy_id", acaid.value);
                temp.append("year_id", ayear);
                temp.append("academy_date", ddate ? ddate : '');
                temp.append("invoice_no", invno);
                temp.append("attendance_push_notification", attpush);
                temp.append("transport_attendance_push_notification", transportattpush);
                temp.append("fee_structure_push_notification", feestructurepush);
                temp.append("fee_payment_push_notification", feepaymentpush);
                temp.append("homework_push_notification", homeworkpush);
                temp.append("reg_renewal_msg", transportRenewalMsg);
                temp.append("reg_renewal_days", rcount);
                temp.append("tax_renewal_msg", taxrenewl);
                temp.append("tax_renewal_days", taxcount);
                temp.append("poc_renewal_msg", pocrenewal);
                temp.append("poc_renewal_days", poccount);
                temp.append("ins_renewal_msg", insrenewel);
                temp.append("ins_renewal_days", inscount);
                temp.append("transport_notification_time", transportTime);
                temp.append("backup_frequency", backupFrequency);
                temp.append("backup_time", backupTime);
                temp.append("user_id", localStorage.getItem("UID"));
                temp.append("role_id", localStorage.getItem("Role"));
                createsetting(temp).then((res) => {
                    if (res.status === true) {
                        localStorage.setItem("AYear", res.data.year_id);
                        localStorage.setItem("ADate", res.data.academy_date ? res.data.academy_date : '');
                        localStorage.setItem("AAcademy", res.data.academy_id);
                        toast.success(res.message);
                        setErrMsg(false);
                    } else {
                        toast.error(res.message);
                    }
                });
            }
        }
    }
    const sectionHeader = (icon, title, color = "#6259ca") => (
        <div style={{ borderLeft: `4px solid ${color}`, paddingLeft: "12px", marginBottom: "18px" }}>
            <h6 className="mb-0 fw-bold" style={{ color }}>
                {title}
            </h6>
        </div>
    );

    const renewalRows = [
        { label: "Registration",  msgVal: transportRenewalMsg, setMsg: setTransportRenewalMsg, daysVal: rcount,   setDays: setRCount   },
        { label: "Tax",           msgVal: taxrenewl,           setMsg: setTaxRenewal,          daysVal: taxcount, setDays: setTaxCount  },
        { label: "POC",           msgVal: pocrenewal,          setMsg: setPocRenewal,          daysVal: poccount, setDays: setPocCount  },
        { label: "Insurance",     msgVal: insrenewel,          setMsg: setInsRenewal,          daysVal: inscount, setDays: setInsCount  },
    ];

    return (
        <Fragment>
            <div className="page-header reported-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Default Settings</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a>Settings</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Default Settings</li>
                    </ol>
                </div>
            </div>

            {/* ── General Settings ── */}
            <Card className="custom-card mb-3">
                <Card.Body>
                    {sectionHeader("fa fa-cog", "General Settings")}
                    <div className="row">
                        {localStorage.getItem("Role") === "1" && (
                            <div className="col-xl-3 col-sm-6 mb-3">
                                <label className="form-label">Select Academy <span className="text-danger">*</span></label>
                                <Select
                                    className="default-select"
                                    placeholder="Select Academy"
                                    value={acaid}
                                    options={aclist}
                                    onChange={handleAcademy}
                                    isSearchable={true}
                                    isClearable
                                />
                                {errmsg && acaid === "" && <span className="text-danger tx-12">Academy is required</span>}
                            </div>
                        )}
                        <div className="col-xl-3 col-sm-6 mb-3">
                            <label className="form-label">Academic Year <span className="text-danger">*</span></label>
                            <select className="default-select form-control wide" value={ayear} onChange={(e) => setAYear(e.target.value)}>
                                <option value="" disabled>Select Academic Year</option>
                                {alist.map((item) => <option value={item.id} key={item.id}>{item.aca_year}</option>)}
                            </select>
                            {errmsg && ayear === "" && <span className="text-danger tx-12">Academic Year is required</span>}
                        </div>
                        <div className="col-xl-3 col-sm-6 mb-3">
                            <label className="form-label">Default Date</label>
                            <input type="date" className="form-control" value={ddate} max={cdate}
                                onChange={(e) => setDDate(e.target.value)}
                                onKeyDown={(e) => e.preventDefault()} />
                        </div>
                        <div className="col-xl-3 col-sm-6 mb-3">
                            <label className="form-label">Invoice Bill No</label>
                            <input type="text" className="form-control" placeholder="Invoice Bill No" value={invno}
                                onChange={(e) => setInvNo(e.target.value)} />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {/* ── Transport Notification ── */}
            <Card className="custom-card mb-3">
                <Card.Body>
                    {sectionHeader("fa fa-bus", "Transport Renewal Notifications", "#f16d75")}
                    <p className="tx-12 text-muted mb-3">Variables: <code>{"{vehicle}"}</code>, <code>{"{route}"}</code>, <code>{"{date}"}</code></p>
                    <div className="table-responsive">
                        <table className="table table-bordered align-middle mb-3" style={{ minWidth: "600px" }}>
                            <thead style={{ background: "#3498db" }}>
                                <tr>
                                    <th style={{ width: "130px" }}>Type</th>
                                    <th>Notification Message</th>
                                    <th style={{ width: "180px" }}>Notify Before (days)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {renewalRows.map((row) => (
                                    <tr key={row.label}>
                                        <td className="fw-semibold">{row.label}</td>
                                        <td>
                                            <textarea className="form-control" rows="2"
                                                value={row.msgVal} onChange={(e) => row.setMsg(e.target.value)} />
                                        </td>
                                        <td>
                                            <input type="number" className="form-control" placeholder="Days"
                                                value={row.daysVal} onChange={(e) => row.setDays(e.target.value)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-sm-6">
                            <label className="form-label">
                                Notification Time <span className="text-danger">*</span>
                                <span className="text-muted tx-12 ms-1">(Daily alerts sent at this time)</span>
                            </label>
                            <input type="time" className="form-control" value={transportTime}
                                onChange={(e) => setTransportTime(e.target.value)} />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {/* ── Push Notifications ── */}
            <Card className="custom-card mb-3">
                <Card.Body>
                    {sectionHeader("fa fa-bell", "Push Notification Messages", "#f7b731")}
                    <div className="row">
                        {[
                            { label: "Attendance",           vars: "{student}, {class}, {section}, {date}, {time}, {status}", val: attpush,           set: setAttPush },
                            { label: "Transport Attendance", vars: "{student}, {vehicle}, {route}, {date}, {time}, {status}", val: transportattpush,  set: setTransportAttPush },
                            { label: "Fee Structure",        vars: "{student}, {feetype}, {amount}, {year}",                   val: feestructurepush, set: setFeeStructurePush },
                            { label: "Fee Payment",          vars: "{student}, {feetype}, {paid}, {pending}, {date}",          val: feepaymentpush,   set: setFeePaymentPush },
                            { label: "Homework",             vars: "{student}, {subject}, {date}",                             val: homeworkpush,     set: setHomeworkPush },
                        ].map((item) => (
                            <div className="col-xl-6 col-sm-12 mb-3" key={item.label}>
                                <label className="form-label fw-semibold">{item.label}</label>
                                <p className="tx-12 text-muted mb-1">Variables: <code>{item.vars}</code></p>
                                <textarea className="form-control" rows="3" value={item.val}
                                    onChange={(e) => item.set(e.target.value)} />
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>

            {/* ── Certificate Images ── */}
            <Card className="custom-card mb-3">
                <Card.Body>
                    {sectionHeader("fa fa-image", "Certificate Header & Footer Images", "#6c757d")}
                    <p className="tx-12 text-muted mb-3">These images will appear at the top and bottom of every generated certificate.</p>
                    <div className="row">
                        {[
                            { type: "header", label: "Header Image", url: certHeaderUrl, file: certHeaderFile, setFile: setCertHeaderFile, setUrl: setCertHeaderUrl },
                            { type: "footer", label: "Footer Image", url: certFooterUrl, file: certFooterFile, setFile: setCertFooterFile, setUrl: setCertFooterUrl },
                        ].map(({ type, label, url, file, setFile, setUrl }) => (
                            <div className="col-xl-6 col-sm-12 mb-3" key={type}>
                                <label className="form-label fw-semibold mb-2">{label}</label>
                                <div className="avatar-upload">
                                    <div className="avatar-preview">
                                        {(file || url) && (
                                            <img
                                                src={file ? URL.createObjectURL(file) : url}
                                                alt={label}
                                            />
                                        )}
                                    </div>
                                    <div className="change-btn mt-2 mb-lg-0 mb-3">
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept=".png, .jpg, .jpeg"
                                            onChange={(e) => setFile(e.target.files[0] || null)}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-primary my-2 me-2"
                                            onClick={() => handleUploadCertImage(type)}
                                            disabled={certUploading[type]}
                                        >
                                            <i className="fa fa-upload me-1"></i>
                                            {certUploading[type] ? "Uploading..." : "Upload"}
                                        </button>
                                        <a className="btn btn-secondary my-2" onClick={() => { setUrl(""); setFile(null); }}>
                                            Remove
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>

            {/* ── Database Backup ── */}
            <Card className="custom-card mb-3">
                <Card.Body>
                    {sectionHeader("fa fa-database", "Database Backup", "#19b159")}
                    <div className="row align-items-end">
                        <div className="col-xl-3 col-sm-6 mb-3">
                            <label className="form-label">Backup Frequency</label>
                            <select className="default-select form-control wide" value={backupFrequency}
                                onChange={(e) => setBackupFrequency(e.target.value)}>
                                <option value="">-- Select Frequency --</option>
                                <option value="daily">Daily</option>
                                <option value="weekly">Weekly (Every Sunday)</option>
                                <option value="monthly">Monthly (Last day of month)</option>
                                <option value="yearly">Yearly (Dec 31st)</option>
                            </select>
                        </div>
                        <div className="col-xl-5 col-sm-6 mb-3">
                            <label className="form-label">
                                Backup Time
                                <span className="text-muted tx-12 ms-1">(Auto-backup starts at this time)</span>
                            </label>
                            <input type="time" className="form-control" value={backupTime}
                                onChange={(e) => setBackupTime(e.target.value)} />
                        </div>
                        <div className="col-xl-4 col-sm-6 mb-3">
                            {lastBackupAt && (
                                <p className="tx-12 text-muted mb-2">
                                    <i className="fa fa-clock-o me-1"></i>
                                    Last backup: <strong>{moment.utc(lastBackupAt).local().format("DD-MM-YYYY hh:mm A")}</strong>
                                </p>
                            )}
                            <button type="button" className="btn btn-success" onClick={handleDownloadBackup} disabled={backupLoading}>
                                <i className="fa fa-download me-1"></i>
                                {backupLoading ? "Downloading..." : "Download Backup Now"}
                            </button>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {/* ── Push Notification Permission ── */}
            <Card className="custom-card mb-3">
                <Card.Body>
                    {sectionHeader("fa fa-mobile", "Push Notification Permission", "#6259ca")}
                    <div className="d-flex align-items-center gap-3 mb-3">
                        <span className="form-label mb-0">Browser Status:</span>
                        {pushPermission === "granted" && <span className="badge bg-success tx-13">Allowed</span>}
                        {pushPermission === "denied"  && <span className="badge bg-danger tx-13">Blocked</span>}
                        {pushPermission === "default" && <span className="badge bg-warning tx-13">Not yet enabled</span>}
                    </div>
                    {pushPermission === "denied" ? (
                        <div className="alert alert-danger py-2 px-3 tx-13 mb-3">
                            <strong>Notifications are blocked by your browser.</strong>
                            <ol className="mb-0 mt-1 ps-3">
                                <li>Click the <strong>lock icon</strong> in your browser's address bar</li>
                                <li>Set <strong>Notifications</strong> to <strong>Allow</strong></li>
                                <li>Reload the page, then click <strong>Enable Notifications</strong></li>
                            </ol>
                        </div>
                    ) : (
                        <button className="btn btn-primary me-2" onClick={handleEnableNotifications} disabled={pushLoading}>
                            <i className="fa fa-bell me-1"></i>
                            {pushLoading ? "Enabling..." : pushPermission === "granted" ? "Re-register This Device" : "Enable Notifications"}
                        </button>
                    )}
                    {pushPermission === "denied" && (
                        <button className="btn btn-outline-secondary" onClick={() => setPushPermission(Notification.permission)}>
                            Check Again After Allowing
                        </button>
                    )}
                </Card.Body>
            </Card>

            <div className="res-right mb-4">
                <a onClick={handlesubmit} type="button" className="btn btn-success tx-teko">
                    <i className="fa fa-save me-1"></i> Submit
                </a>
            </div>
        </Fragment>
    );
};

export default SettingDefault;
